import React from 'react'
import styles from '../ApproveKYCStyles/ApproveKYCStyles.module.scss'
import { adminKYCStatusSectionDataType } from '../ApproveKYCDataType'

const KYCStatusSection = ({formik, kycDetails}: adminKYCStatusSectionDataType) => {
  return (
    <>
      <hr className='pt-2 text-primary' />
      {/* Begin: Application KYC Status heading */}
      <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-6'>
        Application KYC Status
      </h2>
      {/* End: Application KYC Status heading */}

      {/*Begin::Form Group Application KYC Status */}
      <div className='mx-6'>
        <div className='fv-row'>
          <div className='d-flex justify-content-between w-100 flex-wrap'>
            {/*Begin:Option */}
            <label
              className={`d-flex my-1 ${styles.max_w_30} flex-fill align-items-center justify-content-between cursor-pointer symbol-label bg-light-warning p-2 rounded`}
            >
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='badge badge-warning p-0'>
                    <i className='bi bi-hourglass-top display-7 font-weight-bold text-secondary fs-2'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Pending</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('account_kyc_status')}
                  name='account_kyc_status'
                  type='radio'
                  value={0}
                  id='account_kyc_status'
                  defaultChecked={kycDetails?.account_kyc_status === 0}
                />
              </span>
            </label>
            {/*End::Option */}

            {/*Begin:Option */}
            <label
              className={`d-flex my-1 ${styles.max_w_30} ${styles.bg_light_orange} flex-fill align-items-center justify-content-between cursor-pointer symbol-label p-2 rounded`}
            >
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className={`badge ${styles.badge_orange} p-0`}>
                    <i className='bi bi-hourglass-split display-7 font-weight-bold text-secondary fs-2'></i>
                  </span>
                </span>
                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Processing</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('account_kyc_status')}
                  name='account_kyc_status'
                  type='radio'
                  value={2}
                  id='account_kyc_status'
                  defaultChecked={kycDetails?.account_kyc_status === 2}
                />
              </span>
            </label>
            {/*End::Option */}

            {/*Begin:Option */}
            <label
              className={`d-flex my-1 ${styles.max_w_30} flex-fill align-items-center justify-content-between cursor-pointer symbol-label bg-light-danger p-2 rounded`}
            >
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='badge badge-danger p-0'>
                    <i className='bi bi-x-lg display-7 font-weight-bold text-secondary fs-2'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Rejected</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('account_kyc_status')}
                  name='account_kyc_status'
                  type='radio'
                  value={3}
                  id='account_kyc_status'
                  defaultChecked={kycDetails?.account_kyc_status === 3}
                />
              </span>
            </label>
            {/*End::Option */}

            {/*Begin:Option */}
            <label
              className={`d-flex my-1 ${styles.max_w_30} flex-fill align-items-center justify-content-between cursor-pointer symbol-label bg-light-success p-2 rounded`}
            >
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='badge badge-success p-0'>
                    <i className='bi bi-check-lg display-7 font-weight-bold text-secondary fs-2'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Active</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('account_kyc_status')}
                  name='account_kyc_status'
                  type='radio'
                  value={1}
                  id='account_kyc_status'
                  defaultChecked={kycDetails?.account_kyc_status === 1}
                />
              </span>
            </label>
            {/*End::Option */}

            {/*Begin:Option */}
            <label
              className={`d-flex my-1 ${styles.max_w_30} flex-fill align-items-center justify-content-between cursor-pointer symbol-label ${styles.bg_light_green} p-2 rounded`}
            >
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className={`badge ${styles.badge_green} p-0`}>
                    <i className='bi bi-check2-all display-7 font-weight-bold text-light fs-2'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Resubmitted</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('account_kyc_status')}
                  name='account_kyc_status'
                  type='radio'
                  value={4}
                  id='account_kyc_status'
                  defaultChecked={kycDetails?.account_kyc_status === 4}
                />
              </span>
            </label>
            {/*End::Option */}

            {/*Begin:Option */}
            <label
              className={`d-flex my-1 ${styles.max_w_30} flex-fill align-items-center justify-content-between cursor-pointer symbol-label bg-light-dark p-2 rounded`}
            >
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='badge badge-dark p-0'>
                    <i className='bi bi-exclamation display-7 font-weight-bolder text-light fs-1'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Terminated</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('account_kyc_status')}
                  name='account_kyc_status'
                  type='radio'
                  value={5}
                  id='account_kyc_status'
                  defaultChecked={kycDetails?.account_kyc_status === 5}
                />
              </span>
            </label>
            {/*End::Option */}
          </div>
          <div className='h-20px'>
            {formik.touched.account_kyc_status && formik.errors.account_kyc_status && (
              <div className='fv-help-block color-red'>{formik.errors.account_kyc_status}</div>
            )}
          </div>
        </div>
      </div>
      {/*End::Form Group Application KYC Status */}
    </>
  )
}

export default KYCStatusSection
